"use client";

import { PublicSiteHeader } from "@/components/shared/public-site-header";

interface PublicSearchHeaderProps {
  onScrollLockChange?: (locked: boolean) => void;
}

export function PublicSearchHeader({ onScrollLockChange }: PublicSearchHeaderProps) {
  return (
    <PublicSiteHeader
      activeAction="guest_find_list"
      homeHref="/"
      onScrollLockChange={onScrollLockChange}
      sectionHrefPrefix="/"
      surface="solid"
    />
  );
}
